import { defineComponent as _defineComponent } from 'vue'
import EmailDomainsTab from './tabs/EmailDomainsTab.vue';
import ReplyToTab from './tabs/ReplyToTab.vue';
import UnsubscribeEmailsTab from './tabs/UnsubscribeEmailsTab.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsAccountEmailDomains',
  setup(__props) {

const tabItems = [
	{
		tab: 'Email sending domains',
		title: 'Email sending domains',
		component: EmailDomainsTab,
	},
	{
		tab: 'Reply-to email addresses',
		title: 'Reply-to email addresses',
		component: ReplyToTab,
	},
	{
		tab: 'Unsubscribe email addresses',
		title: 'Unsubscribe email addresses',
		component: UnsubscribeEmailsTab,
	},
];

return { __sfc: true,tabItems }
}

})